export default {
  placeholder: {
    en: 'Search Scentbird...',
  },
  topRatedTitle: {
    en: 'Perfumes that we love',
  },
  notFound: {
    en: 'Sorry, we couldn’t find what you were searching for. Try browsing our best sellers...',
  },
  somethingWrong: {
    en: 'Something went wrong, please try again later',
  },
}
